import { useState, useEffect, useContext } from 'react'
import { Row, Col, Modal, Form } from 'react-bootstrap'
import { FormInput } from '../../../components/formElements/FormInput'
import CodeMaintenanceService from '../../../services/CodeMaintenanceService'
import { Typeahead } from 'react-bootstrap-typeahead'
import { validateFormFields } from '../../../utils/index'
import { toast } from 'react-toastify'
import CommonService from '../../../services/CommonService'
import BaseService from '../../../services/BaseService';
import { UserContext } from '../../../UserContext'

const AddOrganization = (props) => {
    const { onModalClose } = props;
    const user = useContext(UserContext);
    const [orgTypes, setOrgTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [formErrors, setFormErrors] = useState({});

    const [orgRequest, setOrgRequest] = useState({
        "orgName": "",
        "orgShortName": "",
        "activeInd": "Y",
        "orgTypeId": "",
        "orgType": "",
        "orgDivision": "Financing Participant",
        "orgDivisionId": "292"
    });

    useEffect(() => {
        async function fetchOrgTypes() {
            var obj = {
                msgId: "null",
                sysId: null,
                opr: "GetLookups",
                hdrStruct: null,
                queryParam: null,
                reqData: { cdiacCode: "ORGT", active: "Y" },
            };

            await CodeMaintenanceService.getAllCodes(obj)
                .then((res) => res)
                .then((result) => {
                    const filteredList = result.data.responses[0].filter(el => el.activeInd === "Y");
                    const orgTypesListNew = [];
                    filteredList.forEach((orgType, i) => {
                        let obj = {};
                        obj = orgType;
                        obj.value = orgType.cdiacCodeValueId;
                        obj.label = orgType.cdiacCodeValueDesc;
                        orgTypesListNew.push(obj);
                    })

                    setOrgTypes(orgTypesListNew);
                    setIsLoading(false);
                })
        }

        fetchOrgTypes();
        
    }, []);

    const handleOrgChange = (e, key) => {
        const val = (key === "orgName") ? e.target.value : (e.length ? e[0].cdiacCodeValueId : "");

        setOrgRequest(prevState => ({
            ...prevState, [key]: val
        }))
    }

    const handleOrgShortNameChange = e => {
        const { name, value } = e.target;
        setOrgRequest(prevState => ({
            ...prevState, [name]: value
        }))
    }

    const saveOrganization = () => {

        var obj = {
            msgId: null,
            sysId: null,
            opr: "addOrganization",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                organization: {
                    "orgName": orgRequest.orgName,
                    "orgShortName": orgRequest.orgShortName,
                    "orgTypeId": orgRequest.orgTypeId,
                    "orgDivisionId": orgRequest.orgDivisionId,
                    "activeInd": orgRequest.activeInd,
                    "createUser": CommonService.getUserName(user),
                    "lastUpdateUser": CommonService.getUserName(user)
                }
            },
        };

        BaseService.processRequest(obj)
            .then((res) => res)
            .then((result) => {
                if (result.data.errors[0]) {
                    toast.error(result.data.errors[0].message);
                } else {
                    toast.success("Organization Created Successfully.");
                    onModalClose();
                }
            });
    }

    const submitForm = (e) => {
        let form = e.target.closest('form#filerForm');
        let formErrors = validateFormFields(form.elements);

        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formErrors);
        } else {
            setFormErrors({});
            saveOrganization();
        }
    }

    return (
        <Modal show={true} onHide={onModalClose}>
            <Modal.Header closeButton>
                <h3>Add New Organization</h3>
            </Modal.Header>

            <Modal.Body>
                <div className="panel panel-default">
                    <div className="form">
                        <form id="filerForm">
                            <div className="organizationForm">
                                <Row>
                                    <Col md={6} className="control">
                                        <FormInput
                                            type="text"
                                            name="orgName"
                                            label="Organization Name"
                                            isrequired="true"
                                            validations={["required"]}
                                            onChange={(e) => handleOrgChange(e, 'orgName')}
                                            maxLength="120"
                                        />
                                        {formErrors['orgName'] && <span className="error">{formErrors['orgName']}</span>}
                                    </Col>
                                    <Col md={6}>
                                        <label><span className="required">*</span>Organization Type:</label>
                                        <Typeahead
                                            id="orgTypeId"
                                            name="orgTypeId"
                                            placeholder="Choose Org Type..."
                                            labelKey="cdiacCodeValueDesc"
                                            onChange={(e) => handleOrgChange(e, 'orgTypeId')}
                                            options={orgTypes}
                                            inputProps={{ 'data-validations': 'required', name: 'orgTypeId' }}
                                            isLoading={isLoading}
                                        />
                                        {formErrors['orgTypeId'] && <span className="error">{formErrors['orgTypeId']}</span>}
                                    </Col>
                                    <Col md={6} className="control">
                                        <label>Organization Short Name:</label>
                                        <input type="text" name="orgShortName"
                                            onChange={(e) => handleOrgShortNameChange(e)}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <FormInput type="text" label="Division" name="orgType" value={orgRequest.orgDivision} disabled={true}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <label>Active Indicator: </label>
                                        <Form.Check
                                            inline
                                            label="No"
                                            name="activeInd"
                                            value="N"
                                            type="radio"
                                            id="activeInd_0"
                                            checked={orgRequest.activeInd === 'N'}
                                            disabled={true}
                                        />
                                        <Form.Check
                                            inline
                                            label="Yes"
                                            name="activeInd"
                                            value="Y"
                                            type="radio"
                                            id="activeInd_1"
                                            checked={orgRequest.activeInd === 'Y'}
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>
                            </div>

                            <div className="btn-div">
                                <div className="fright">
                                    <button className=" custom-button-secondary btn-secondary" type="button" onClick={onModalClose}>Cancel</button> {" "}
                                    <button className="custom-button " type="button" onClick={(e) => submitForm(e)}>Submit</button>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddOrganization